import React from 'react';
import './styles/global.scss';
import { Route, Routes } from 'react-router-dom'; // Change 'Switch' to 'Routes'
import Howto from './pages/HowTo';
import OpenCamera from './pages/openCamer';
import SkinAnalysis from './pages/skinAnalysis';
import SkinReportPage from './pages/skinReport';
import ProductRecommendation from './pages/productRecommendation';
import AcneIssue from './pages/acneReport';
import SkinDiary from './pages/mySkinDiary';
import ReportHistory from './pages/reportHistory';
import PhotoHistory from './pages/photoHistory';
import DetailBlog from './pages/detailBlog';
// TODO: remove the previous use reference
// import LoaderWithImg from './components/common/loaderWithBgImg'
import LoaderWithImg from './components/micro/loaderWithBgImg/loaderWithBgImg';
import { LandingPage } from './pages/LandingPage';

function App() {
  return (
    <div className="app">
      <Routes>
        {/* <Route path='/' element = { <LandingPage /> } /> */}
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/howTo" element={<Howto />} />
        <Route path="/openCamera" element={<OpenCamera />} />
        <Route path="/reportAnalysis" element={<SkinAnalysis />} />
        <Route path="/skinReport" element={<SkinReportPage />} />
        <Route path="/skinReport/:id" element={<SkinReportPage />} />

        <Route path="/productRecommendation" element={<ProductRecommendation />} />
        <Route path="/acneReport" element={<AcneIssue />} />
        <Route path="/mySkinDiary" element={<SkinDiary />} />
        <Route path="/reportHistory" element={<ReportHistory />} />
        <Route path="/photoHistory" element={<PhotoHistory />} />
        <Route path="/detailBlog2" element={<DetailBlog />} />
        <Route path="/detailBlog" element={<DetailBlog />} />
        <Route path="/loaderWithBgImg" element={<LoaderWithImg />} />
      </Routes>
    </div>
  );
}

export default App;
